<p *transloco="let t" [innerHTML]="'core.footer.copyright' | transloco" class="title"
    [ngClass]="{'text-7': !isMobile, 'text-7-small': isSmall, 'text-7-xsmall': isXSmall}"></p>